import { render, staticRenderFns } from "./SwitchTiers.vue?vue&type=template&id=2b086bb2&"
import script from "./SwitchTiers.vue?vue&type=script&lang=js&"
export * from "./SwitchTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports